var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProtein1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 178.354,
    height: 157.917,
    viewBox: "0 0 178.354 157.917",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 30.618,
    height: 40.969,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(-103.305 -2958.656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    transform: "translate(133.122 2992.562) rotate(-44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M.015,27.583,0,30.54a22.8,22.8,0,0,0,16.984-7.678,22.81,22.81,0,0,0,6.644,17.505c.208.208.422.4.635.6l2.506-1.712q-.54-.468-1.053-.98c-5.669-5.67-7.292-14.024-4.364-22.013a8.164,8.164,0,1,0-2.884-.957C14.878,22.875,7.919,27.541.015,27.583M17.227,8.173a5.218,5.218,0,1,1,5.218,5.218,5.219,5.219,0,0,1-5.218-5.218",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(193.779 2958.657) rotate(2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112-2",
    "data-name": "Group 112",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59-2",
    "data-name": "Path 59",
    d: "M.015,27.583,0,30.54a22.8,22.8,0,0,0,16.984-7.678,22.81,22.81,0,0,0,6.644,17.505c.208.208.422.4.635.6l2.506-1.712q-.54-.468-1.053-.98c-5.669-5.67-7.292-14.024-4.364-22.013a8.164,8.164,0,1,0-2.884-.957C14.878,22.875,7.919,27.541.015,27.583M17.227,8.173a5.218,5.218,0,1,1,5.218,5.218,5.219,5.219,0,0,1-5.218-5.218",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(109.148 3052.599) rotate(-101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112-3",
    "data-name": "Group 112",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59-3",
    "data-name": "Path 59",
    d: "M.015,27.583,0,30.54a22.8,22.8,0,0,0,16.984-7.678,22.81,22.81,0,0,0,6.644,17.505c.208.208.422.4.635.6l2.506-1.712q-.54-.468-1.053-.98c-5.669-5.67-7.292-14.024-4.364-22.013a8.164,8.164,0,1,0-2.884-.957C14.878,22.875,7.919,27.541.015,27.583M17.227,8.173a5.218,5.218,0,1,1,5.218,5.218,5.219,5.219,0,0,1-5.218-5.218",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(126.45 3103.166) rotate(-139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112-4",
    "data-name": "Group 112",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59-4",
    "data-name": "Path 59",
    d: "M.015,27.583,0,30.54a22.8,22.8,0,0,0,16.984-7.678,22.81,22.81,0,0,0,6.644,17.505c.208.208.422.4.635.6l2.506-1.712q-.54-.468-1.053-.98c-5.669-5.67-7.292-14.024-4.364-22.013a8.164,8.164,0,1,0-2.884-.957C14.878,22.875,7.919,27.541.015,27.583M17.227,8.173a5.218,5.218,0,1,1,5.218,5.218,5.219,5.219,0,0,1-5.218-5.218",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(185.697 3108.134) rotate(164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112-5",
    "data-name": "Group 112",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59-5",
    "data-name": "Path 59",
    d: "M.015,27.583,0,30.54a22.8,22.8,0,0,0,16.984-7.678,22.81,22.81,0,0,0,6.644,17.505c.208.208.422.4.635.6l2.506-1.712q-.54-.468-1.053-.98c-5.669-5.67-7.292-14.024-4.364-22.013a8.164,8.164,0,1,0-2.884-.957C14.878,22.875,7.919,27.541.015,27.583M17.227,8.173a5.218,5.218,0,1,1,5.218,5.218,5.219,5.219,0,0,1-5.218-5.218",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(228.338 3093.88) rotate(134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112-6",
    "data-name": "Group 112",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59-6",
    "data-name": "Path 59",
    d: "M.015,27.583,0,30.54a22.8,22.8,0,0,0,16.984-7.678,22.81,22.81,0,0,0,6.644,17.505c.208.208.422.4.635.6l2.506-1.712q-.54-.468-1.053-.98c-5.669-5.67-7.292-14.024-4.364-22.013a8.164,8.164,0,1,0-2.884-.957C14.878,22.875,7.919,27.541.015,27.583M17.227,8.173a5.218,5.218,0,1,1,5.218,5.218,5.219,5.219,0,0,1-5.218-5.218",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(228.338 3093.88) rotate(134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112-7",
    "data-name": "Group 112",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59-7",
    "data-name": "Path 59",
    d: "M.015,27.583,0,30.54a22.8,22.8,0,0,0,16.984-7.678,22.81,22.81,0,0,0,6.644,17.505c.208.208.422.4.635.6l2.506-1.712q-.54-.468-1.053-.98c-5.669-5.67-7.292-14.024-4.364-22.013a8.164,8.164,0,1,0-2.884-.957C14.878,22.875,7.919,27.541.015,27.583M17.227,8.173a5.218,5.218,0,1,1,5.218,5.218,5.219,5.219,0,0,1-5.218-5.218",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(281.659 3063.891) rotate(106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112-8",
    "data-name": "Group 112",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59-8",
    "data-name": "Path 59",
    d: "M.015,27.583,0,30.54a22.8,22.8,0,0,0,16.984-7.678,22.81,22.81,0,0,0,6.644,17.505c.208.208.422.4.635.6l2.506-1.712q-.54-.468-1.053-.98c-5.669-5.67-7.292-14.024-4.364-22.013a8.164,8.164,0,1,0-2.884-.957C14.878,22.875,7.919,27.541.015,27.583M17.227,8.173a5.218,5.218,0,1,1,5.218,5.218,5.219,5.219,0,0,1-5.218-5.218",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "matrix(0.799, 0.602, -0.602, 0.799, 249.983, 2989.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112-9",
    "data-name": "Group 112",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59-9",
    "data-name": "Path 59",
    d: "M.015,27.583,0,30.54a22.8,22.8,0,0,0,16.984-7.678,22.81,22.81,0,0,0,6.644,17.505c.208.208.422.4.635.6l2.506-1.712q-.54-.468-1.053-.98c-5.669-5.67-7.292-14.024-4.364-22.013a8.164,8.164,0,1,0-2.884-.957C14.878,22.875,7.919,27.541.015,27.583M17.227,8.173a5.218,5.218,0,1,1,5.218,5.218,5.219,5.219,0,0,1-5.218-5.218",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtein1);
export default __webpack_public_path__ + "static/media/protein-1.4d58856fb7281f2d7c566cde21858a2c.svg";
export { ForwardRef as ReactComponent };